import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

type CardGroup = {
    id: number
    title: string  
    card: any
}

type CardGroupDto = {
    title: string  
}

export const CardGroupsApi = createApi({
    reducerPath: 'CardGroupsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api'
    }),
    endpoints: builder => ({
        getCardGroup: builder.query<CardGroup, { id: number }>({
            query: id => ({ url: `/card-groups/${id}` })
        }),
        getAllCardGroups: builder.query<CardGroup[], void>({
            query: () => ({ url: '/card-groups' })
        }),
        createCardGroup: builder.mutation<any, CardGroupDto>({
            query: (data)=> ({url: `/card-groups`, method: "POST", body: data}),
        }),
    })
})

export const { useGetCardGroupQuery, useGetAllCardGroupsQuery, useCreateCardGroupMutation } = CardGroupsApi
